<template>
  <div class="top_box">
    <div
      class="banner"
      :style="{ height: chooseKey === 2 ? '660px' : '660px' }"
    >
      <div class="title">{{ bannerMessage.title }}</div>
      <div class="line"></div>
      <div class="content">{{ bannerMessage.subtitle }}</div>
      <img :src="bannerMessage.thumbUrl" alt="" />

      <div class="menu-container">
        <div
          v-for="(item, index) in menuList"
          :key="'item' + index"
          :class="item.key === chooseKey ? 'is_select' : ''"
          @click="changeItem(item.key)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <framework v-if="chooseKey === 1"></framework>
    <partyWindow v-if="chooseKey === 2"></partyWindow>
    <videoPeriodical v-if="chooseKey === 3"></videoPeriodical>
    <honestConstruction v-if="chooseKey === 4"></honestConstruction>
    <!-- <div class="main_box" :style="{ top: chooseKey === 2 ? '-186px' : '0px' }">
      <div class="menu_box">
        <div class="right_article">
          <framework v-if="chooseKey === 1"></framework>
          <partyWindow v-if="chooseKey === 2"></partyWindow>
          <videoPeriodical v-if="chooseKey === 3"></videoPeriodical>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script setup>
import { ref, watch, onMounted } from "vue";
import api from "@/api/api";
import videoPeriodical from "./components/videoPeriodical.vue";
import partyWindow from "./components/partyWindowNew.vue";
import framework from "./components/frameworkNew.vue";
import honestConstruction from "./components/honest.vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
let chooseKey = ref(2);
let bannerMessage = ref({});
let menuList = ref([
  {
    name: "党建阵地",
    key: 2,
  },
  {
    name: "机电清风",
    key: 4,
  },
  {
    name: "火蓝机电",
    key: 1,
  },

  {
    name: "视频刊物",
    key: 3,
  },
]);
const changeItem = (key) => {
  // chooseKey.value = key;
  router.push({
    query: {
      id: key,
    },
  });
};

const getBanner = async () => {
  let res = await api.getPageConfigDetail(105);
  if (res.code === "0") {
    bannerMessage.value = res.res.data;
  }
};
getBanner();
watch(
  () => route,
  (newval) => {
    if (newval && newval.query.id) {
      chooseKey.value = newval.query.id * 1;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  },
  { deep: true, immediate: true }
);
</script>
<style lang="less" scoped>
.top_box {
  width: 100%;

  .banner {
    width: 100%;
    // height: 612px;
    position: relative;
    overflow: hidden;

    .menu-container {
      position: absolute;
      width: 100%;
      top: 572px;
      display: flex;
      justify-content: center;
      align-items: center;

      & > div {
        width: 299px;
        height: 68px;
        text-align: center;
        line-height: 68px;
        font-size: 20px;
        background: #ffffff;
        color: #333333;
        cursor: pointer;
      }

      .is_select {
        background: #006ab1;
        color: #ffffff;
      }
    }

    .title {
      position: absolute;
      left: 170px;
      top: 120px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #333333;
    }

    .line {
      position: absolute;
      left: 170px;
      top: 223px;
      width: 60px;
      height: 2px;
      background: rgba(0, 0, 0, 0.4);
    }

    .content {
      position: absolute;
      left: 170px;
      top: 254px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #333333;
    }

    img {
      width: 100%;
      height: 660px;
      position: absolute;
      z-index: -1;
    }
  }

  .main_box {
    width: 100vw;
    padding: 42px 8.33vw 0px 8.33vw;
    box-sizing: border-box;
    position: relative;

    .menu_box {
      display: flex;
      position: relative;

      .left_menu {
        height: 78px;
        width: 180px;
        background: #f0f0f0;
        margin-right: 63px;
        z-index: 3;

        .left_title {
          width: 100%;
          height: 74px;
          background: #006ab1;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;

          .title1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
          }

          .title2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
            margin-top: 4px;
          }
        }

        .left_item {
          .item {
            cursor: pointer;
            text-align: right;
            height: 37px;
            line-height: 37px;
            padding-right: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            background: #f0f0f0;
          }

          .choose {
            background: #223e62 !important;
            color: #ffffff !important;
          }
        }
      }

      .right_article {
        z-index: 2;
        position: relative;
        width: calc(100% - 0);
      }
    }
  }
}
</style>
